import AssignmentNotificationSetting from './AssignmentNotificationSetting';

export default AssignmentNotificationSetting;
